import React from "react";

function Home(){
    return (
        <div>
            <div>
              <ul>
                  <li>Discover the different services that are available to improve your business analytics.</li>
                  <li>Convert your speadsheets to dynamic reporting dashboards.</li>
                  <li>Develop new business insights with up to date meaningful analysis and reports.</li>
              </ul>
          </div>
          <div>
              <div>
                  <span class='contentSubHeading'>Using Power BI in your organization.</span>
              </div>

              <ul>
                  <li>Provides effective data visualisation.</li>
                  <li>Streamlines data integration with other existing systems.</li>
                  <li>Provides self service analytics empowerment.</li>
                  <li>Allows effortless collaboration and sharing of data related insights.</li>
              </ul>
          </div>

          <div>
              <div>
                  <span class='contentSubHeading'>Past Clients</span>
              </div>
              <ul>
                  <li>Victorian Education Department</li>
                  <li>VCAA. Victorian Curriculum and Assessment Authority</li>
                  <li>Coles IT.</li>
                  <li>Coliban Water</li>
                  <li>Assa Abloy. Lockwood Locks.</li>
              </ul>
          </div>
        </div>
    )

}

export default Home;